export const sizeMappings = {
    'Billboard_970x250': [
        {
            'viewport': [1050, 200],
            'slot': [[970, 250], [970, 90], [980, 120], [728, 90]]
        },
        {
            'viewport': [0, 0],
            'slot': []
        }
    ],
    'Interstitial_landscape_480x320': [
        {
            'viewport': [1024, 768],
            'slot': [[336, 280], [300, 250], [480, 320]]
        },

        {
            'viewport': [0, 0],
            'slot': []
        },
    ],
    'Triple_billboard_750x300': [
        {
            'viewport': [1024, 768],
            'slot': [[750, 300], [750, 200], [728, 90]]
        },
        {
            'viewport': [0, 0],
            'slot': []
        },
    ],
    'Netboard_580x400': [
        {
            'viewport': [1024, 768],
            'slot': [[480, 320], [580, 400]]
        },
        {
            'viewport': [0, 0],
            'slot': []
        },
    ],
}

export const adUnits = {
    "title1": {
        "name": "Billboard_970x250",
        "size": ['fluid', [970, 250], [970, 90], [980, 120], [728, 90]],
        "category1": "main",
        "placeholder": "/img/gptPlaceholders/980x250-min.png"
    },
    "title2": {
        "name": "Triple_billboard_750x300",
        "size": ['fluid', [750, 300], [750, 200], [728, 90]],
        "category1": "main",
        "placeholder": "/img/gptPlaceholders/750x300-min.png"
    },
    "title3": {
        "name": "Rectangle_200x400",
        "size": ['fluid', [200, 200], [180, 150], [200, 400]],
        "category1": "main",
        "placeholder": "/img/gptPlaceholders/200x400-min.png"
    },
    "surveys1": {
        "name": "Billboard_970x250",
        "size": ['fluid', [970, 250], [970, 90], [980, 120], [728, 90]],
        "category1": "surveys",
        "category2": "surveys",
        "placeholder": "/img/gptPlaceholders/980x250-min.png"
    },
    "surveys2": {
        "name": "Triple_billboard_750x300",
        "size": ['fluid', [750, 300], [750, 200], [728, 90]],
        "category1": "surveys",
        "category2": "surveys",
        "placeholder": "/img/gptPlaceholders/750x300-min.png"
    },
    "surveys3": {
        "name": "Vertical_Rectangle_240x400",
        "size": ['fluid', [240, 400], [250, 250], [200, 200], [250, 360], [200, 400]],
        "category1": "surveys",
        "category2": "surveys",
        "placeholder": "/img/gptPlaceholders/250x360-min.png"
    },
    "surveys4": {
        "name": "Small_Square_200x200",
        "size": ['fluid', [200, 200], [180, 150]],
        "category1": "surveys",
        "category2": "surveys",
        "placeholder": "/img/gptPlaceholders/200x200.png"
    },
    "surveyPage1": {
        "name": "Billboard_970x250",
        "size": ['fluid', [970, 250], [970, 90], [980, 120], [728, 90]],
        "category1": "surveys",
        "category2": "survey",
        "placeholder": "/img/gptPlaceholders/980x250-min.png"
    },
    "surveyPage2": {
        "name": "Triple_billboard_750x300",
        "size": ['fluid', [750, 300], [750, 200], [728, 90]],
        "category1": "surveys",
        "category2": "survey",
        "placeholder": "/img/gptPlaceholders/750x300-min.png"
    },
    "surveyPage3": {
        "name": "Vertical_Rectangle_240x400",
        "size": ['fluid', [240, 400], [250, 250], [200, 200], [250, 360], [200, 400]],
        "category1": "surveys",
        "category2": "survey",
        "placeholder": "/img/gptPlaceholders/250x360-min.png"
    },
    "library1": {
        "name": "Billboard_970x250",
        "size": ['fluid', [970, 250], [970, 90], [980, 120], [728, 90]],
        "category1": "library",
        "category2": "library",
        "placeholder": "/img/gptPlaceholders/980x250-min.png"
    },
    "library2": {
        "name": "Small_Square_200x200",
        "size": ['fluid', [200, 200], [180, 150]],
        "category1": "library",
        "category2": "library",
        "placeholder": "/img/gptPlaceholders/750x300-min.png"
    },
    "library3": {
        "name": "Interstitial_landscape_480x320",
        "size": ['fluid', [336, 280], [300, 250], [480, 320]],
        "category1": "library",
        "category2": "library",
        "placeholder": "/img/gptPlaceholders/480x320-min.png"
    },
    "libraryPage1": {
        "name": "Billboard_970x250",
        "size": ['fluid', [970, 250], [970, 90], [980, 120], [728, 90]],
        "category1": "library",
        "category2": "libraryPage",
        "placeholder": "/img/gptPlaceholders/980x250-min.png"
    },
    "libraryPage2": {
        "name": "Triple_billboard_750x300",
        "size": ['fluid', [750, 300], [750, 200], [728, 90]],
        "category1": "library",
        "category2": "libraryPage",
        "placeholder": "/img/gptPlaceholders/750x300-min.png"
    },
    "material1": {
        "name": "Billboard_970x250",
        "size": ['fluid', [970, 250], [970, 90], [980, 120], [728, 90]],
        "category1": "library",
        "category2": "material",
        "placeholder": "/img/gptPlaceholders/980x250-min.png"
    },
    "material2": {
        "name": "Triple_billboard_750x300",
        "size": ['fluid', [750, 300], [750, 200], [728, 90]],
        "category1": "library",
        "category2": "material",
        "placeholder": "/img/gptPlaceholders/750x300-min.png"
    },
    "material3": {
        "name": "Portrait_300x1050",
        "size": ['fluid', [300, 1050], [300, 600], [240, 400], [300, 250], [200, 400]],
        "category1": "library",
        "category2": "material",
        "placeholder": "/img/gptPlaceholders/300x1050-min.png"
    },
    "courses1": {
        "name": "Billboard_970x250",
        "size": ['fluid', [970, 250], [970, 90], [980, 120], [728, 90]],
        "category1": "courses",
        "category2": "courses",
        "placeholder": "/img/gptPlaceholders/980x250-min.png"
    },
    "courses2": {
        "name": "Triple_widescreen_250x360",
        "size": ['fluid', [250, 250], [250, 360]],
        "category1": "courses",
        "category2": "courses",
        "placeholder": "/img/gptPlaceholders/250x300-min.png"
    },
    "courses3": {
        "name": "Interstitial_landscape_480x320",
        "size": ['fluid', [336, 280], [300, 250], [480, 320]],
        "category1": "courses",
        "category2": "courses",
        "placeholder": "/img/gptPlaceholders/480x320-min.png"
    },
    "courses4": {
        "name": "Vertical_Rectangle_240x400",
        "size": ['fluid', [240, 400], [250, 250], [200, 200], [250, 360], [200, 400]],
        "category1": "courses",
        "category2": "courses",
        "placeholder": "/img/gptPlaceholders/250x360-min.png"
    },
    "courses5": {
        "name": "Triple_billboard_750x300",
        "size": ['fluid', [750, 300], [750, 200], [728, 90]],
        "category1": "courses",
        "category2": "courses",
        "placeholder": "/img/gptPlaceholders/750x300-min.png"
    },
    "myCourses1": {
        "name": "Billboard_970x250",
        "size": ['fluid', [970, 250], [970, 90], [980, 120], [728, 90]],
        "category1": "courses",
        "category2": "myCourses",
        "placeholder": "/img/gptPlaceholders/980x250-min.png"
    },
    "myCourses2": {
        "name": "Triple_billboard_750x300",
        "size": ['fluid', [750, 300], [750, 200], [728, 90]],
        "category1": "courses",
        "category2": "myCourses",
        "placeholder": "/img/gptPlaceholders/750x300-min.png"
    },
    "course1": {
        "name": "Billboard_970x250",
        "size": ['fluid', [970, 250], [970, 90], [980, 120], [728, 90]],
        "category1": "courses",
        "category2": "course",
        "placeholder": "/img/gptPlaceholders/980x250-min.png"
    },
    "course2": {
        "name": "Triple_billboard_750x300",
        "size": ['fluid', [750, 300], [750, 200], [728, 90]],
        "category1": "courses",
        "category2": "course",
        "placeholder": "/img/gptPlaceholders/750x300-min.png"
    },
    "coursePreview1": {
        "name": "Billboard_970x250",
        "size": ['fluid', [970, 250], [970, 90], [980, 120], [728, 90]],
        "category1": "courses",
        "category2": "course",
        "placeholder": "/img/gptPlaceholders/980x250-min.png"
    },
    "coursePreview2": {
        "name": "Triple_billboard_750x300",
        "size": ['fluid', [750, 300], [750, 200], [728, 90]],
        "category1": "courses",
        "category2": "course",
        "placeholder": "/img/gptPlaceholders/750x300-min.png"
    },
    "coursePreview3": {
        "name": "Vertical_Rectangle_240x400",
        "size": ['fluid', [240, 400], [250, 250], [200, 200], [250, 360], [200, 400]],
        "category1": "courses",
        "category2": "course",
        "placeholder": "/img/gptPlaceholders/250x360-min.png"
    },
    "conferences1": {
        "name": "Billboard_970x250",
        "size": ['fluid', [970, 250], [970, 90], [980, 120], [728, 90]],
        "category1": "conferences",
        "category2": "conferences",
        "placeholder": "/img/gptPlaceholders/980x250-min.png"
    },
    "conferences2": {
        "name": "Triple_widescreen_250x360",
        "size": ['fluid', [250, 250], [250, 360]],
        "category1": "conferences",
        "category2": "conferences",
        "placeholder": "/img/gptPlaceholders/250x300-min.png"
    },
    "conferencePage1": {
        "name": "Billboard_970x250",
        "size": ['fluid', [970, 250], [970, 90], [980, 120], [728, 90]],
        "category1": "conferences",
        "category2": "conference",
        "placeholder": "/img/gptPlaceholders/980x250-min.png"
    },
    "conferencePage2": {
        "name": "Netboard_580x400",
        "size": ['fluid', [480, 320], [580, 400]],
        "category1": "conferences",
        "category2": "conference",
        "placeholder": "/img/gptPlaceholders/980x250-min.png"
    },
    "conferencePage3": {
        "name": "Half_page_300x600",
        "size": ['fluid', [300, 600], [240, 400], [300, 250], [200, 400]],
        "category1": "conferences",
        "category2": "conference",
        "placeholder": "/img/gptPlaceholders/300x600-min.png"
    },
    "organizations1": {
        "name": "Billboard_970x250",
        "size": ['fluid', [970, 250], [970, 90], [980, 120], [728, 90]],
        "category1": "organizations",
        "category2": "organizations",
        "placeholder": "/img/gptPlaceholders/980x250-min.png"
    },
    "organizations2": {
        "name": "Interstitial_landscape_480x320",
        "size": ['fluid', [336, 280], [300, 250], [480, 320]],
        "category1": "organizations",
        "category2": "organizations",
        "placeholder": "/img/gptPlaceholders/480x320-min.png"
    },
    "organizationPage1": {
        "name": "Billboard_970x250",
        "size": ['fluid', [970, 250], [970, 90], [980, 120], [728, 90]],
        "category1": "organizations",
        "category2": "organization",
        "placeholder": "/img/gptPlaceholders/980x250-min.png"
    },
    "organizationPage2": {
        "name": "Netboard_580x400",
        "size": ['fluid', [480, 320], [580, 400], [200, 400]],
        "category1": "organizations",
        "category2": "organization",
        "placeholder": "/img/gptPlaceholders/580x400-min.png"
    },
    "organizationPage3": {
        "name": "Half_page_300x600",
        "size": ['fluid', [300, 600], [240, 400], [300, 250]],
        "category1": "organizations",
        "category2": "organization",
        "placeholder": "/img/gptPlaceholders/300x600-min.png"
    },
    "search1": {
        "name": "Billboard_970x250",
        "size": ['fluid', [970, 250], [970, 90], [980, 120], [728, 90]],
        "category1": "search",
        "placeholder": "/img/gptPlaceholders/980x250-min.png"
    },
    "search2": {
        "name": "Triple_billboard_750x300",
        "size": ['fluid', [750, 300], [750, 200], [728, 90]],
        "category1": "search",
        "placeholder": "/img/gptPlaceholders/750x300-min.png"
    },
    "search3": {
        "name": "Vertical_Rectangle_240x400",
        "size": ['fluid', [240, 400], [250, 250], [200, 200], [250, 360], [200, 400]],
        "category1": "search",
        "placeholder": "/img/gptPlaceholders/250x360-min.png"
    }
}
